import get from 'lodash/get';

import getServiceLocation from '@/lib/getServiceLocation';
import { getAuthenticatedFetchJSON } from './fetch';

const fetchDrivers = (injectedFetch = fetch) => {
    const configuredFetch = getAuthenticatedFetchJSON(injectedFetch);

    return configuredFetch(`${getServiceLocation('vehicleinspection')}/drivers`)
        .then((res) => get(res, 'items', []))
        .catch(() => []);
};

export default fetchDrivers;
